export default __webpack_public_path__ + "static/media/amul.03ea6c4d.png";